<template>
  <div class="questions one-more-thing">
    <GoBack currentScreen="one-more-thing" />

    <div class="questions__number">Just one more thing</div>

    <!-- fade in/out title -->
    <transition name="slide-fade" mode="out-in">
      <h1>{{title}}</h1>
    </transition>
    <!-- fade in/out questions items -->
    <transition name="fade" mode="out-in">
      <div class="questions__items" :key="currentQuestion.number">

        <div v-for="(sheen, i) in sheenArray" 
            :key="i"
            :class="sheen.id"
            class="question__item"
            v-on:click="selectSheen(i)">
          <div
              class="item__circle"
              :class="{ 'active': sheen.id === activeItem.id, 
                        'disabled': sheen.id !== activeItem.id && activeItem.id !== null,
                        'no-name': !sheen.name
                      }"
              v-bind:style="[{'backgroundColor': 'rgb('+ chosenColor.red + ',' + chosenColor.green + ',' + chosenColor.blue + ')'}, 
                              sheen.image ? {'backgroundImage': 'url(' + sheen.image + ')' } : null]"
              @click="selectSheen(i)">
              <div class="sheen__sheen-effect">
                <div class="layer-1"></div>
                <div class="layer-2"></div>
                <div class="layer-3">
                  <div class="shine"></div>
                </div>
              </div>
          </div>
          <div class="sheen__slider-background">
            <div class="sheen__slider-dot"></div>
            <div class="sheen__slider-line"></div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div class="sheen__details">
        <p class="sheen__name">{{activeItem ? activeItem.name : ""}}</p>
        <p class="sheen__copy" v-html="activeCopy"></p>
      </div>
    </transition>

    <AnimatedButton
      :class="isLight ? 'light' : 'dark'"
      class="sheen__button"
      :style="'background-color: rgb('+ chosenColor.red + ',' + chosenColor.green + ',' + chosenColor.blue + ')'"
      :text="'Buy online at Bunnings'" ref="viewOnColourwall"
      v-on:click="handleOnClick()"></AnimatedButton>
  </div>
</template>

<script>
import GoBack from './elements/GoBack.vue'
import AnimatedButton from './elements/AnimatedButton'
import allColours from '../assets/data/allColours.json'
import { sheenData, bunningsUrls } from '../assets/data/data.js'
import { keyBy } from 'lodash'
import {lightOrDark} from '../assets/data/lightOrDark'

export default {
  name: 'Questions',
  components: {
    GoBack,
    AnimatedButton
  },

  data() {
    return {
      activeItem: sheenData[0], // Defaulting value to low-sheen
      sheenArray: []
    }
  },
  computed: {
    allColourMap() {
      return keyBy(allColours, color => color.colourName.toLowerCase())
    },
    chosenColor : function() {
      return this.allColourMap[this.$store.state.chosenColor.colourName.toLowerCase()]
    },
    currentQuestion: function() {
      return this.$store.state.currentQuestion;
    },
    currentQuestionColours() {
      return this.currentQuestion.colours;
    },
    currentPattern : function() {
      return this.$store.state.currentPattern;
    },
    interiorOrExterior() {
      let intExt = "";
      if (this.$store.state.interiorOrExterior.length === 0) {
        intExt = "interior";
      } else {
        intExt = this.$store.state.interiorOrExterior;
      }

      return intExt;
    },
    colorBase : function() {
      let base = "";
      if (this.chosenColor == undefined || this.chosenColor.base == undefined || this.chosenColor.base === "") {
        base = "white";
      } else if (this.chosenColor.base.interior != undefined ) {
        // If this colour has different base based on interior/exterior paint
        base = this.chosenColor.base[this.interiorOrExterior];
      } else {
        // If this colour has just 1 base
        base = this.chosenColor.base;
      }
      return base;
    },
    lastQuestion: function() {
      return this.$store.state.lastQuestion;
    },
    selectedColor : function() {
      return this.$store.state.selectedColor;
    },
    sheenData : function() {

      return sheenData;
    },
    wallType () {
      return this.$route.query.wall || 'large'
    },
    ctaUrl : function() {
      if (this.activeItem || this.activeItem.id) {
        return bunningsUrls[this.interiorOrExterior][this.colorBase][this.activeItem.id];
      } else {
        return "";
      }
    },
    title() {
      if (this.sheenArray.length > 1) {
        return "Choose your level of sheen"
      } else {
        return "Your level of sheen"
      }
    },
    activeCopy : function() {
      return this.activeItem ? this.activeItem.copy : ""
    },
    isLight() {
      return lightOrDark('rgb('+this.chosenColor.red+','+this.chosenColor.green+','+this.chosenColor.blue+')');
    }
  },
  mounted() {
    // Save the colour choice before the bg is updated
    this.$store.commit('updateChosenColor', this.$store.state.selectedColor);
    // Set bg colour to be white
    this.$store.commit('updateBg', [255,255,255] );

    this.initSheenData();
	},
  methods: {
    resetActiveItem() {
      this.activeItem = null;
    },
    selectSheen(i){
      this.activeItem = this.sheenArray[i];
      var shinysel = '.question__item.'+this.activeItem.id+' .layer-3';
      var allShinyLayers = this.$el.querySelectorAll('.layer-3');
      for (var j = 0; j < allShinyLayers.length; j++) {
        var thisLayer = allShinyLayers[j];
        thisLayer.classList.remove('enter');
      }

      if (this.activeItem.id == "semi-gloss" || this.activeItem.id == "gloss") {
        var shinyLayer = this.$el.querySelector(shinysel);
        setTimeout(function() {
          shinyLayer.classList.add('enter')
        }, 200)
      }
    },
    handleOnClick() {
      window.open(this.ctaUrl, "_blank") ;
    },
    initSheenData() {
      var urlObject = bunningsUrls[this.interiorOrExterior][this.colorBase];

      for (var key in urlObject) {
        var sheen = sheenData[key];
        var urlObjectValue = urlObject[key];

        if (urlObjectValue !== "" && sheen != undefined) {
          this.sheenArray.push(sheen);
          if (key == "low-sheen") {
            this.activeItem = sheenData[key];
          }

        }
      }
    },
    getColourLabel() {
      return this.chosenColor ? this.chosenColor.colourName : null;
    },
  },
}
</script>

<style>

.layer-3 {
  width: 120px;
    transform: rotate(20deg);
    margin-left: -27px;
}


.shine {
  width: 30px;
  height: 70px;
  background: linear-gradient(to left, rgba(255,255,255,0),  rgba(255,255,255,0.3),rgba(255,255,255,0));
  transform: skew(-20deg);
  margin-left: -50px;
  transition: 1s ease;
}

.enter .shine {
  margin-left: 100px;
}

.active .gloss .layer-1,
.active .gloss .layer-2 {
  transform: rotate(20deg);
}
</style>